import { AxiosResponse } from 'axios'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { DateTime } from 'services/database/reportsDatabase'
import { RequestCDU, RequestGENERIC, RequestREAD } from 'services/Instances'

export const ContractNGTServices = () => {
  const path = 'ContratoNGT'

  const create = async (requestObj: ContractNgt): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}`, requestObj)

  const update = async (requestObj: ContractUpdate): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}`, requestObj)

  const noSapUpdate = async (
    requestObj: CreateContractNgt
  ): Promise<AxiosResponse> => await RequestCDU.put(`${path}`, requestObj)

  const anexarEvidenciaContrato = async (
    objRequest: RequestAnexarEvidenciaContrato
  ): Promise<AxiosResponse> =>
    await RequestCDU.post('AnexarDocEvidenciaContrato', objRequest)

  const deleteAnexarEvidenciaContrato = async (
    id: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete('AnexarDocEvidenciaContrato/Delete/' + id)

  const deleteAnexarEvidenciaSubContrato = async (
    id: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete('AnexarDocEvidenciaSubContrato/Delete/' + id)

  const getAllGrpMercadoria = async (): Promise<
    AxiosResponse<IGenericEntityResponse<IGrupoMercadoriaResponse[]>>
  > => await RequestREAD.get('Sap/GetAllGrpMercadoria')

  const getAllHierarquiaProduto = async (): Promise<
    AxiosResponse<IGenericEntityResponse<IHierarquiaProdutoResponse[]>>
  > => await RequestREAD.get('Sap/GetAllHierarquiaProduto')

  const aggregatedContratos = async (): Promise<
    AxiosResponse<IAggregatedContratos>
  > => await RequestGENERIC.get('aggregatedContratos_contrato')

  return {
    aggregatedContratos,
    anexarEvidenciaContrato,
    create,
    deleteAnexarEvidenciaContrato,
    deleteAnexarEvidenciaSubContrato,
    getAllGrpMercadoria,
    getAllHierarquiaProduto,
    noSapUpdate,
    update
  }
}

export interface IHierarquiaProdutoResponse {
  idHierarquiaProduto: number
  cdHierarquiaProduto: string
  txDescricao: string
  nivelHierarquia: number
}

export interface IGrupoMercadoriaResponse {
  idGrupoMercadoria: number
  cdGrupoMercLegado: string
  txDescricao: string
  dtAtualizacaoSap: DateTime
  dtUltAtualizacao: DateTime
}

export interface IContratoMovimentacaoResponse {
  ContratoID: number;
	CDContrato: string;
	FLStatusMobilizacao: string;
	AnoMesCompetencia: string;
}

export interface IContratoNmCentro {
  nmCentro: string;
  nmUnidadeGestora: string;
}

export const ContractServices = () => {
  const path = 'Contrato'

  const VerificarContratoMovimentacao = async (
    idContrato: number
    ): Promise<AxiosResponse<IGenericEntityResponse<IContratoMovimentacaoResponse>>> =>
      await RequestREAD.get(`Movimentacao/VerificarContratoMovimentacao/${idContrato}`);

  const getNmCentroByCodigoContrato = async (
        codigoContrato: number
  ): Promise<AxiosResponse<IContratoNmCentro>> =>
      await RequestREAD.get(`${path}/GetNmCentroByCodContato/${codigoContrato}`);

  const GetAllContracts = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(path)

  const GetContractById = async (
    id: string | number
  ): Promise<AxiosResponse<ResponseContractById>> =>
    await RequestREAD.get(`${path}/GetById/${id}`)

  const GetByCodigo = async (
    cdContrato: string | number
  ): Promise<AxiosResponse<ResponseContractById>> =>
    await RequestREAD.get(`${path}/GetByCodigo`, {
      params: {
        cdContrato: cdContrato
      }
    })

  const GetContractNgtById = async (
    id: number
  ): Promise<AxiosResponse<ContractNgtResponse>> =>
    await RequestREAD.get(`${path}/GetById/${id}`)
  const GetContractByContrato = async (
    cd: string
  ): Promise<
    AxiosResponse<IGenericEntityResponse<ContratoAutocompleteResponseDTO[]>>
  > => await RequestREAD.get(`${path}/AutocompleteContrato/?cdContrato=${cd}`)

  const GetContractByCd = async (
    cd: string | number,
    hasDinamicSearch: Boolean = false
  ): Promise<
    AxiosResponse<IGenericEntityResponse<IContratoAutoCompleteResposeDto[]>>
  > =>
    await RequestREAD.get(
      `${path}/Autocomplete/?cdContrato=${cd}&hasDinamicSearch=${hasDinamicSearch}`
    )

  const GetContractByCodigo = async (
    cd: string | number
  ): Promise<AxiosResponse<any>> =>
    await RequestREAD.patch(
      `${path}/AutocompleteContratoFornecedor/?cdContrato=${cd}`
    )

  const GetAllForGrid = async ({
    PageNumber,
    PageSize
  }: GetAllForGridProps): Promise<AxiosResponse<RequestGetAllTableData>> =>
    await RequestREAD.get(`${path}/GetAllForGrid`, {
      params: { PageNumber: PageNumber, PageSize: PageSize }
    })

  const GetByParamsForGrid = async ({
    PageNumber,
    PageSize,
    CdContrato,
    CdDocto,
    NmFornecedor,
    NmContraparte,
    DtInicioSap,
    DtFimSap
  }: GetByParamsForGridProps): Promise<AxiosResponse<RequestGetAllTableData>> =>
    await RequestREAD.get(`${path}/GetByParamsForGrid`, {
      params: {
        CdContrato,
        CdDocto,
        DtFimSap,
        DtInicioSap,
        NmContraparte,
        NmFornecedor,
        PageNumber,
        PageSize
      }
    })

  const DeleteContractById = async (
    contractID: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete`, { params: { id: contractID } })

  const searchContract = async (
    params: ISearchContractQuery
  ): Promise<AxiosResponse<ISearchContractResponse>> =>
    await RequestREAD.get(`${path}/Autocomplete`, {
      params: { ...params, hasDinamicSearch: true }
    })

  return {
    DeleteContractById,
    GetAllContracts,
    GetAllForGrid,
    GetByCodigo,
    GetByParamsForGrid,
    GetContractByCd,
    GetContractByCodigo,
    GetContractByContrato,
    GetContractById,
    GetContractNgtById,
    searchContract,
    VerificarContratoMovimentacao,
    getNmCentroByCodigoContrato
  }
}

export interface IAggregatedContratos {
  contrato_centroPlanta: ICentroPlantaResponse
  contrato_gruposMercadoriaSap: IGrpMercadoriaResponse[]
  contrato_hierarquiaProdutoSap: IHierarquiaProdutosResponse[]
  contrato_setorContrato: ISetoresResponse[]
  contrato_tipoCre: ITipoCreResponse[]
  contrato_unidadeGestora: IUnidadeGestoraResponse[]
}

export interface IGrpMercadoriaResponse {
  cdGrupoMercLegado?: string
  txDescricao: string
}

export interface IHierarquiaProdutosResponse {
  cdHierarquiaProduto?: string
  txDescricao: string
}

export interface ISetoresResponse {
  idSetorContrato?: number
  dsSetorContrato: string
}

export interface ITipoCreResponse {
  idTipoCre: number
  txDenominacao: string
}

export interface IUnidadeGestoraResponse {
  idUnidadeGestora: number
  nmTipoUnidade: string
  nmUnidade: string
  idUnidadePai: number
  numeroUnidade: string
  sgUnidade: string
}

export interface ICentroPlantaResponse {
  entity: ICentroPlanta[]
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface ICentroPlanta {
  idCentroPlanta: number
  txDescricao: string
  empresaId?: string
  txCidd?: string
  txEndr?: string
  nuCnpj?: string
}

interface ISearchContractQuery {
  cdContrato?: string
  cdFornecedor?: string
  hasDinamicSearch?: boolean
}

export interface ISearchContractEntityResponse {
  idContrato: number
  cdContrato: string
}

interface ISearchContractResponse {
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
  entity: ISearchContractEntityResponse[]
}

export interface IContratoAutoCompleteResposeDto {
  idContrato: number
  cdContrato: string
}

export interface IContratoResponseDto {
  idContrato: number
  contratoPrincipalId: any
  fornecedorId: number
  empresaId: number
  centroPlantaId: number
  tipoCreId: number
  setorId: number
  contraparteUsuarioId: number
  compradorUsuarioId: number
  unidadeGestoraId: number
  cdContrato: string
  cdContratoPrincipal: string
  cnpj: string
  nmFornecedor: string
  nmEmpresa: string
  nmCentro: string
  txObjetoContrato: string
  nmCRE: string
  txCno?: string
  flSocio: boolean
  dtVigenciaInicio: string
  dtVigenciaFim: string
  dtVigInicoReal: string
  dtVigFimReal: string
  vlContratual: number
  nmSetor: string
  flRecorrente: boolean
  flEncerrado: boolean
  flDenuncia: boolean
  flAlerta: boolean
  flSubcontrato: boolean
  txDenuncia: any
  txAlerta: any
  matriculaContraparte: any
  nmContraparte: string
  ramalContraparte: string
  emailContraparte: string
  contraparteSub: any[]
  matriculaComprador: string
  nmComprador: string
  ramalComprador: string
  emailComprador: string
  nmUnidadeGestora: string
  nmUnidade: string
  cdGrupoMercadoria: string
  cdHierarquiaProd: string
  txObservacao: string
  txEmail: any[]
}

export interface RequestAnexarEvidenciaContrato {
  documentoPaiId?: number
  usuarioId: number
  contratoId?: number
  forncedorId: number
  tipoPendenciaId?: number
  tipoDocumentoId?: number
  nuAnoMesCompetencia?: number
  nomeArquivo: string
  descricao: string
  file: string
}

export interface TxEmail {
  idContratoNotificacao?: number
  contratoId?: number
  tipoNotificacaoId?: number
  txEmail: string
  FlExclusao?: boolean
}

export interface ContractUpdate {
  idContrato: number
  cdContrato: string
  fornecedorId: number
  centroPlantaId: number
  empresaId: number
  txObjetoContrato: string
  tipoCreId: number
  txCno?: string
  flSocio: boolean
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  dtVigInicoReal: Date
  dtVigFimReal: Date
  vlContratual: number
  setorContratoId: number
  flRecorrente: boolean
  flAtivo: boolean
  flEncerrado: boolean
  flDenuncia: boolean
  flAlerta: boolean
  flSubcontrato: boolean
  txDenuncia: string
  txAlerta: string
  contraparteUsuarioId: number
  compradorUsuarioId: number
  idUnidGestora: number
  cdGrupoMercadoria: string
  cdHierarquiaProd: string
  txObservacao: string
  contratoPrincipalId: number
  txEmail: TxEmail[]
  listContraparteSubstituto: number[]
  url: string
}

export interface ContratoAutocompleteResponseDTO {
  idContrato: number
  cdContrato: string
  fornecedorId: number
  cdDocto: string
  nmFornecedor: string
  empresaId: number
  txDescricaoEmpresa: string
  centroPlantaId: number
  txDescricaoCentroPlanta: string
}

interface GetAllForGridProps {
  PageNumber?: number
  PageSize?: number
}

interface GetByParamsForGridProps {
  CdContrato?: string
  CdDocto?: string
  NmFornecedor?: string
  NmContraparte?: string
  DtInicioSap?: string
  DtFimSap?: string
  PageNumber?: number
  PageSize?: number
}

interface RequestGetAllTableData {
  detalhe: string
  entity: GetAllTableData
  mensagem: string
  sucesso: boolean
  tipo: string
}

interface GetAllTableData {
  firstItemOnPage: 1
  hasNextPage: true
  hasPreviousPage: false
  isFirstPage: true
  isLastPage: false
  items: TableData[]
  lastItemOnPage: 5
  pageCount: 7
  pageNumber: 1
  pageSize: 5
  totalItemCount: 35
}

interface TableData {
  cdContrato: string
  cdDocto: string
  nmFornecedor: string
  txDescricao: string
  nmContraparte: string
  nmMatricula: string
  txDenominacao: string
  dtCadastro: string
}

export interface ContractNgt {
  idContrato?: number
  cdContrato?: string
  fornecedorId?: number
  empresaId?: number
  centroPlantaId?: number
  txObjetoContrato?: string
  tipoCreId?: number
  txCno?: string
  flSocio?: boolean
  dtVigenciaInicio?: Date
  dtVigenciaFim?: Date
  dtVigInicoReal?: Date
  dtVigFimReal?: Date
  vlContratual?: number
  setorId?: number
  flRecorrente?: boolean
  flEncerrado?: boolean
  flSubcontrato?: boolean
  contraparteUsuarioId?: number
  contraparteUsuarioSubstitutoId?: Array<number>
  compradorUsuarioId?: number
  contratoPrincipalId?: number
  cdGrupoMercadoria?: string
  cdHierarquiaProd?: string
}

export interface ResponseContractById {
  idContrato: number
  itemProdutoPrincipalId: any
  contratoPrincipalId?: any
  cdChamadoCervello?: number
  fornecedorId: number
  empresaId: number
  centroPlantaId: number
  tipoCreId: number
  setorId: number
  contraparteUsuarioId: number
  compradorUsuarioId: number
  unidadeGestoraId: number
  cdContrato: string
  cdContratoPrincipal: string
  cnpj: string
  nmFornecedor: string
  nmEmpresa: string
  nmCentro: string
  txObjetoContrato: string
  nmCRE: string
  txCno?: string
  flSocio: boolean
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  dtVigInicoReal: Date
  dtVigFimReal: Date
  vlContratual: number
  nmSetor: string
  flRecorrente: boolean
  flEncerrado: boolean
  flDenuncia: boolean
  flAlerta: boolean
  flSubcontrato: boolean
  txDenuncia?: any
  txAlerta?: any
  matriculaContraparte?: any
  nmContraparte: string
  ramalContraparte: string
  emailContraparte: string
  contraparteSub: any[]
  matriculaComprador: string
  nmComprador: string
  ramalComprador: string
  emailComprador: string
  nmUnidadeGestora: string
  nmUnidade: string
  cdGrupoMercadoria: string
  cdHierarquiaProd: string
  txObservacao: string
  txEmail: any[]
  idUnidadeComprador: any
}

export interface CreateContractNgt {
  idContrato?: number
  cdContrato: string
  fornecedorId: number
  centroPlantaId: number
  empresaId: number
  txObjetoContrato: string
  itemProdutoId?: number
  tipoCreId: number
  txCno: string
  flSocio: boolean
  dtVigenciaInicio: Date
  dtVigenciaFim: Date
  dtVigInicoReal: Date
  dtVigFimReal: Date
  vlContratual: number
  setorContratoId: number
  flRecorrente: boolean
  flEncerrado: boolean
  flDenuncia: boolean
  flAlerta: boolean
  flSubcontrato: boolean
  txDenuncia: string
  txAlerta: string
  contraparteUsuarioId: number
  compradorUsuarioId?: number
  idUnidGestora: number
  cdGrupoMercadoria: string
  hierarquiaId?: number
  txObservacao: string
  contratoPrincipalId?: number
  url: string
  flAtivo?: boolean
  listContraparteSubstituto?: number[]
  txEmail?: IEmailList[] | String[]
  listAnexarDocs?: ISaveFileRequest[]
  contraparteUsuarioSubstitutoId?: number[]
}

export interface ISubstitutosInputs {
  emailSubstituto: string
  idSubstituto: number
  matriculaSubstituto: string
  nmSubstituto: string
  ramalSubstituto: string
}

export interface IEmailList {
  idContratoNotificacao?: number
  contratoId?: number
  tipoNotificacaoId?: number
  txEmail: string
}

export interface ISaveFileRequest {
  usuarioId: number
  tipoPendenciaId: number
  tipoDocumentoId: number
  nuAnoMesCompetencia: number
  nomeArquivo: string
  descricao: string
  file: string
}

export interface ContractNgtResponse {
  centroPlantaId: number
  compradorUsuarioId: number
  idUnidadeComprador: number
  contraparteUsuarioId: number
  empresaId: number
  fornecedorId: number
  idContrato: number
  itemProdutoPrincipalId: number
  setorId: number
  tipoCreId: number
  unidadeGestoraId: number
  contratoPrincipalId: number
  hierarquiaProdutoId: number
  vlContratual: number
  cdContrato: string
  cdContratoPrincipal: string
  cdGrupoMercadoria: string
  cnpj: string
  emailComprador: string
  emailContraparte: string
  matriculaComprador: string
  matriculaContraparte: string
  nmCentro: string
  nmComprador: string
  nmContraparte: string
  nmCRE: string
  nmEmpresa: string
  nmFornecedor: string
  nmSetor: string
  nmUnidade: string
  nmUnidadeGestora: string
  nmGrupoMercadoria: string
  nmHierarquiaProduto: string
  ramalComprador: string
  ramalContraparte: string
  txAlerta: string
  txCno: string
  txDenuncia: string
  txObjetoContrato: string
  txObservacao: string
  dtVigenciaFim: string | Date
  dtVigenciaInicio: string | Date
  dtVigFimReal: string | Date
  dtVigInicoReal: string | Date
  flAlerta: boolean
  flAtivo: boolean
  flDenuncia: boolean
  flEncerrado: boolean
  flRecorrente: boolean
  flSocio: boolean
  flSubcontrato: boolean
  flUnidadeManual:boolean
  contraparteSubstitutos: IContraparteSubstitutos[]
  txEmails: { txEmail: string }[]
}

export interface IContraparteSubstitutos {
  emailContraparteSub: string
  matriculaContraparteSub: string
  nmContraparteSub: string
  ramalContraparteSub: string
  usuarioId: number
}

export interface IContractForm {
  vlContratual?: string
  txObjetoContrato?: string
  txDenuncia?: string
  txAlerta?: string
  nmContraparte?: string
  matriculaContraparte?: string
  empresaId?: number
  empresa?: number
  emailsTrabalhistas?: string[]
  centroPlantaId?: number
  cdContrato?: string
  cdGrupoMercadoria?: string
  CRE?: string
  dtVigenciaInicio?: Date
  dtVigenciaFim?: Date
  dtVigInicoReal?: Date
  dtVigFimReal?: Date
  cnpj?: string
  nmFornecedor?: string
  empresaName?: string
  centroPlantaName?: string
  creName?: string
  txCno?: string
  flSocio?: boolean
  flAlerta?: boolean
  flDenuncia?: boolean
  flEncerrado?: boolean
  flRecorrente?: boolean
  flSubcontrato?: boolean
  hierarquiaId?: number
  setorName?: string
  ramalContraparte?: string
  emailContraparte?: string
  matriculaComprador?: string
  nmComprador?: string
  ramalComprador?: string
  emailComprador?: string
  txObservacao?: string
  nmUnidadeGestora?: string
  idUnidadeGestora?: number
  setorId?: number
  fornecedor?: number
  cdHierarquiaProd?: string
}
